import image from "../../assets/pagebanner4.jpg";

export const SHOPPING = [
  {
    img: image,
  },
];
